/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * MyYoast
 * The MyYoast Api
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CancelProvisionedSubscriptionDto,
  CreateProvisionedSubscriptionDto,
  ListProvisionedSubscriptionsParams,
  ProvisionedSubscriptionListResponseDto,
  SetProvisionedSiteDto,
  SubscriptionProvisioningResponseDto
} from '../models';

import { customFetch } from '../../customFetch';
import type { ErrorType } from '../../customFetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getCreateProvisionedSubscriptionUrl = () => {




  return `/api/provisioning/subscriptions/create`
}

/**
 * Creates a subscription for a customer.
 * @summary Create a subscription
 */
export const createProvisionedSubscription = async (createProvisionedSubscriptionDto: CreateProvisionedSubscriptionDto, options?: Parameters<typeof customFetch>[1]): Promise<SubscriptionProvisioningResponseDto> => {

  return customFetch<SubscriptionProvisioningResponseDto>(getCreateProvisionedSubscriptionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createProvisionedSubscriptionDto)
  }
);}





export const getCreateProvisionedSubscriptionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProvisionedSubscription>>, TError,{data: CreateProvisionedSubscriptionDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProvisionedSubscription>>, TError,{data: CreateProvisionedSubscriptionDto}, TContext> => {

const mutationKey = ['createProvisionedSubscription'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProvisionedSubscription>>, {data: CreateProvisionedSubscriptionDto}> = (props) => {
          const {data} = props ?? {};

          return  createProvisionedSubscription(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProvisionedSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof createProvisionedSubscription>>>
    export type CreateProvisionedSubscriptionMutationBody = CreateProvisionedSubscriptionDto
    export type CreateProvisionedSubscriptionMutationError = ErrorType<void>

    /**
 * @summary Create a subscription
 */
export const useCreateProvisionedSubscription = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProvisionedSubscription>>, TError,{data: CreateProvisionedSubscriptionDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProvisionedSubscription>>,
        TError,
        {data: CreateProvisionedSubscriptionDto},
        TContext
      > => {
      return useMutation(getCreateProvisionedSubscriptionMutationOptions(options), queryClient);
    }
    export const getListProvisionedSubscriptionsUrl = (params?: ListProvisionedSubscriptionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/provisioning/subscriptions?${stringifiedParams}` : `/api/provisioning/subscriptions`
}

/**
 * Lists the subscriptions provisioned by the calling provisioner, newest first, optionally narrowed by customer email.
 * @summary List provisioned subscriptions
 */
export const listProvisionedSubscriptions = async (params?: ListProvisionedSubscriptionsParams, options?: Parameters<typeof customFetch>[1]): Promise<ProvisionedSubscriptionListResponseDto> => {

  return customFetch<ProvisionedSubscriptionListResponseDto>(getListProvisionedSubscriptionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProvisionedSubscriptionsQueryKey = (params?: ListProvisionedSubscriptionsParams,) => {
    return [
    `/api/provisioning/subscriptions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProvisionedSubscriptionsQueryOptions = <TData = Awaited<ReturnType<typeof listProvisionedSubscriptions>>, TError = ErrorType<void>>(params?: ListProvisionedSubscriptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProvisionedSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProvisionedSubscriptionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProvisionedSubscriptions>>> = ({ signal }) => listProvisionedSubscriptions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProvisionedSubscriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProvisionedSubscriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof listProvisionedSubscriptions>>>
export type ListProvisionedSubscriptionsQueryError = ErrorType<void>


export function useListProvisionedSubscriptions<TData = Awaited<ReturnType<typeof listProvisionedSubscriptions>>, TError = ErrorType<void>>(
 params: undefined |  ListProvisionedSubscriptionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProvisionedSubscriptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProvisionedSubscriptions>>,
          TError,
          Awaited<ReturnType<typeof listProvisionedSubscriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProvisionedSubscriptions<TData = Awaited<ReturnType<typeof listProvisionedSubscriptions>>, TError = ErrorType<void>>(
 params?: ListProvisionedSubscriptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProvisionedSubscriptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProvisionedSubscriptions>>,
          TError,
          Awaited<ReturnType<typeof listProvisionedSubscriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProvisionedSubscriptions<TData = Awaited<ReturnType<typeof listProvisionedSubscriptions>>, TError = ErrorType<void>>(
 params?: ListProvisionedSubscriptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProvisionedSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List provisioned subscriptions
 */

export function useListProvisionedSubscriptions<TData = Awaited<ReturnType<typeof listProvisionedSubscriptions>>, TError = ErrorType<void>>(
 params?: ListProvisionedSubscriptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProvisionedSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProvisionedSubscriptionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProvisionedSubscriptionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listProvisionedSubscriptions>>, TError = ErrorType<void>>(params?: ListProvisionedSubscriptionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProvisionedSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProvisionedSubscriptionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProvisionedSubscriptions>>> = ({ signal }) => listProvisionedSubscriptions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProvisionedSubscriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProvisionedSubscriptionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listProvisionedSubscriptions>>>
export type ListProvisionedSubscriptionsSuspenseQueryError = ErrorType<void>


export function useListProvisionedSubscriptionsSuspense<TData = Awaited<ReturnType<typeof listProvisionedSubscriptions>>, TError = ErrorType<void>>(
 params: undefined |  ListProvisionedSubscriptionsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProvisionedSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProvisionedSubscriptionsSuspense<TData = Awaited<ReturnType<typeof listProvisionedSubscriptions>>, TError = ErrorType<void>>(
 params?: ListProvisionedSubscriptionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProvisionedSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProvisionedSubscriptionsSuspense<TData = Awaited<ReturnType<typeof listProvisionedSubscriptions>>, TError = ErrorType<void>>(
 params?: ListProvisionedSubscriptionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProvisionedSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List provisioned subscriptions
 */

export function useListProvisionedSubscriptionsSuspense<TData = Awaited<ReturnType<typeof listProvisionedSubscriptions>>, TError = ErrorType<void>>(
 params?: ListProvisionedSubscriptionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProvisionedSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProvisionedSubscriptionsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOneProvisionedSubscriptionUrl = (id: string,) => {




  return `/api/provisioning/subscriptions/${id}`
}

/**
 * Get a single subscription that was provisioned for a third party
 * @summary Get a subscription
 */
export const getOneProvisionedSubscription = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<SubscriptionProvisioningResponseDto> => {

  return customFetch<SubscriptionProvisioningResponseDto>(getGetOneProvisionedSubscriptionUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOneProvisionedSubscriptionQueryKey = (id: string,) => {
    return [
    `/api/provisioning/subscriptions/${id}`
    ] as const;
    }


export const getGetOneProvisionedSubscriptionQueryOptions = <TData = Awaited<ReturnType<typeof getOneProvisionedSubscription>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOneProvisionedSubscription>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneProvisionedSubscriptionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneProvisionedSubscription>>> = ({ signal }) => getOneProvisionedSubscription(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneProvisionedSubscription>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOneProvisionedSubscriptionQueryResult = NonNullable<Awaited<ReturnType<typeof getOneProvisionedSubscription>>>
export type GetOneProvisionedSubscriptionQueryError = ErrorType<void>


export function useGetOneProvisionedSubscription<TData = Awaited<ReturnType<typeof getOneProvisionedSubscription>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOneProvisionedSubscription>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOneProvisionedSubscription>>,
          TError,
          Awaited<ReturnType<typeof getOneProvisionedSubscription>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOneProvisionedSubscription<TData = Awaited<ReturnType<typeof getOneProvisionedSubscription>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOneProvisionedSubscription>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOneProvisionedSubscription>>,
          TError,
          Awaited<ReturnType<typeof getOneProvisionedSubscription>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOneProvisionedSubscription<TData = Awaited<ReturnType<typeof getOneProvisionedSubscription>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOneProvisionedSubscription>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a subscription
 */

export function useGetOneProvisionedSubscription<TData = Awaited<ReturnType<typeof getOneProvisionedSubscription>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOneProvisionedSubscription>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOneProvisionedSubscriptionQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOneProvisionedSubscriptionSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOneProvisionedSubscription>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneProvisionedSubscription>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneProvisionedSubscriptionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneProvisionedSubscription>>> = ({ signal }) => getOneProvisionedSubscription(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneProvisionedSubscription>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOneProvisionedSubscriptionSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOneProvisionedSubscription>>>
export type GetOneProvisionedSubscriptionSuspenseQueryError = ErrorType<void>


export function useGetOneProvisionedSubscriptionSuspense<TData = Awaited<ReturnType<typeof getOneProvisionedSubscription>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneProvisionedSubscription>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOneProvisionedSubscriptionSuspense<TData = Awaited<ReturnType<typeof getOneProvisionedSubscription>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneProvisionedSubscription>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOneProvisionedSubscriptionSuspense<TData = Awaited<ReturnType<typeof getOneProvisionedSubscription>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneProvisionedSubscription>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a subscription
 */

export function useGetOneProvisionedSubscriptionSuspense<TData = Awaited<ReturnType<typeof getOneProvisionedSubscription>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneProvisionedSubscription>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOneProvisionedSubscriptionSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getRenewSubscriptionUrl = (id: string,) => {




  return `/api/provisioning/subscriptions/${id}/renew`
}

/**
 * Renew the subscription for a new period.
 * @summary Renew a subscription
 */
export const renewSubscription = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<SubscriptionProvisioningResponseDto> => {

  return customFetch<SubscriptionProvisioningResponseDto>(getRenewSubscriptionUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRenewSubscriptionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renewSubscription>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof renewSubscription>>, TError,{id: string}, TContext> => {

const mutationKey = ['renewSubscription'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof renewSubscription>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  renewSubscription(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RenewSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof renewSubscription>>>

    export type RenewSubscriptionMutationError = ErrorType<void>

    /**
 * @summary Renew a subscription
 */
export const useRenewSubscription = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renewSubscription>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof renewSubscription>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getRenewSubscriptionMutationOptions(options), queryClient);
    }
    export const getCancelProvisionedSubscriptionUrl = (id: string,) => {




  return `/api/provisioning/subscriptions/${id}/cancel`
}

/**
 * Cancel the subscription when the period ends, or immediately if that is requested, or the subscription is not valid
 * @summary Cancel a single subscription
 */
export const cancelProvisionedSubscription = async (id: string,
    cancelProvisionedSubscriptionDto: CancelProvisionedSubscriptionDto, options?: Parameters<typeof customFetch>[1]): Promise<SubscriptionProvisioningResponseDto> => {

  return customFetch<SubscriptionProvisioningResponseDto>(getCancelProvisionedSubscriptionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cancelProvisionedSubscriptionDto)
  }
);}





export const getCancelProvisionedSubscriptionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelProvisionedSubscription>>, TError,{id: string;data: CancelProvisionedSubscriptionDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelProvisionedSubscription>>, TError,{id: string;data: CancelProvisionedSubscriptionDto}, TContext> => {

const mutationKey = ['cancelProvisionedSubscription'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelProvisionedSubscription>>, {id: string;data: CancelProvisionedSubscriptionDto}> = (props) => {
          const {id,data} = props ?? {};

          return  cancelProvisionedSubscription(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelProvisionedSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof cancelProvisionedSubscription>>>
    export type CancelProvisionedSubscriptionMutationBody = CancelProvisionedSubscriptionDto
    export type CancelProvisionedSubscriptionMutationError = ErrorType<void>

    /**
 * @summary Cancel a single subscription
 */
export const useCancelProvisionedSubscription = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelProvisionedSubscription>>, TError,{id: string;data: CancelProvisionedSubscriptionDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelProvisionedSubscription>>,
        TError,
        {id: string;data: CancelProvisionedSubscriptionDto},
        TContext
      > => {
      return useMutation(getCancelProvisionedSubscriptionMutationOptions(options), queryClient);
    }
    export const getRefundSubscriptionUrl = (id: string,) => {




  return `/api/provisioning/subscriptions/${id}/refund`
}

/**
 * Refund the subscription. Callable by the provisioner that owns the subscription, or by a MyYoast admin.
 * @summary Refund a single subscription
 */
export const refundSubscription = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<SubscriptionProvisioningResponseDto> => {

  return customFetch<SubscriptionProvisioningResponseDto>(getRefundSubscriptionUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRefundSubscriptionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refundSubscription>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof refundSubscription>>, TError,{id: string}, TContext> => {

const mutationKey = ['refundSubscription'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refundSubscription>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  refundSubscription(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefundSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof refundSubscription>>>

    export type RefundSubscriptionMutationError = ErrorType<void>

    /**
 * @summary Refund a single subscription
 */
export const useRefundSubscription = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refundSubscription>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refundSubscription>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getRefundSubscriptionMutationOptions(options), queryClient);
    }
    export const getSetSiteForProvisionedSubscriptionUrl = (id: string,) => {




  return `/api/provisioning/subscriptions/${id}/set-site`
}

/**
 * Links the subscription to a customer's website. Setting a site the the subscription will remove the site if already set.
 * @summary Link a subscription to a site
 */
export const setSiteForProvisionedSubscription = async (id: string,
    setProvisionedSiteDto: SetProvisionedSiteDto, options?: Parameters<typeof customFetch>[1]): Promise<SubscriptionProvisioningResponseDto> => {

  return customFetch<SubscriptionProvisioningResponseDto>(getSetSiteForProvisionedSubscriptionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setProvisionedSiteDto)
  }
);}





export const getSetSiteForProvisionedSubscriptionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSiteForProvisionedSubscription>>, TError,{id: string;data: SetProvisionedSiteDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setSiteForProvisionedSubscription>>, TError,{id: string;data: SetProvisionedSiteDto}, TContext> => {

const mutationKey = ['setSiteForProvisionedSubscription'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setSiteForProvisionedSubscription>>, {id: string;data: SetProvisionedSiteDto}> = (props) => {
          const {id,data} = props ?? {};

          return  setSiteForProvisionedSubscription(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetSiteForProvisionedSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof setSiteForProvisionedSubscription>>>
    export type SetSiteForProvisionedSubscriptionMutationBody = SetProvisionedSiteDto
    export type SetSiteForProvisionedSubscriptionMutationError = ErrorType<void>

    /**
 * @summary Link a subscription to a site
 */
export const useSetSiteForProvisionedSubscription = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSiteForProvisionedSubscription>>, TError,{id: string;data: SetProvisionedSiteDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setSiteForProvisionedSubscription>>,
        TError,
        {id: string;data: SetProvisionedSiteDto},
        TContext
      > => {
      return useMutation(getSetSiteForProvisionedSubscriptionMutationOptions(options), queryClient);
    }
